import React from 'react';
import SnsUploadForm from '../components/Form/sns/SnsUploadForm';

function SnsUploadPage() {
  return <SnsUploadForm />;
}

export default SnsUploadPage;
